import { createReducer } from 'cdpro-redux-utils'

import { INTL_TEXTS } from '@/common/constants/intl'

import { RootState } from './types'
import { setUser, setPixKey, setIntl } from './actions'

export const INITIAL_STATE: RootState = {
  pix: {} as PixFormated,
  user: undefined,
  intl: INTL_TEXTS.ptbr,
}

const { reducer, addCase } = createReducer<RootState>(INITIAL_STATE)

addCase(setUser, (draft, action) => {
  const { user } = action.payload
  draft.user = user
})

addCase(setPixKey, (draft, action) => {
  const { pix } = action.payload
  draft.pix = pix
})

addCase(setIntl, (draft, action) => {
  const { intl } = action.payload
  draft.intl = intl
})

export default reducer
